import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const u = await login(f.email, f.password);
      toast.success("Welcome back");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch { toast.error("Invalid email or password"); }
    setBusy(false);
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <h1 className="font-heading text-4xl mb-2">Welcome back.</h1>
      <p className="text-neutral-600 mb-8">Log in to book events and view your matches.</p>
      <Button onClick={googleLogin} variant="outline" className="w-full rounded-full mb-4" data-testid="google-login-btn">Continue with Google</Button>
      <div className="text-center text-eyebrow my-4">or</div>
      <form onSubmit={submit} className="space-y-4">
        <Input type="email" placeholder="Email" value={f.email} onChange={e=>setF({...f, email: e.target.value})} required data-testid="login-email" className="rounded-xl" />
        <Input type="password" placeholder="Password" value={f.password} onChange={e=>setF({...f, password: e.target.value})} required data-testid="login-password" className="rounded-xl" />
        <Button type="submit" disabled={busy} className="w-full rounded-full bg-black text-white hover:bg-neutral-800 btn-pill" data-testid="login-submit">
          {busy ? "Logging in…" : "Log in"}
        </Button>
      </form>
      <div className="mt-6 text-sm text-neutral-600 flex justify-between">
        <Link to="/reset" data-testid="link-reset">Forgot password?</Link>
        <Link to="/signup" data-testid="link-signup">Create account →</Link>
      </div>
    </div>
  );
}
